import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: typeof window !== "undefined"
    ? window.location.origin
    : (import.meta.env.VITE_AUTH_URL || "http://localhost:3000"),
  fetchOptions: {
    cache: "no-store",
    headers: {
      "Cache-Control": "no-cache",
      "Pragma": "no-cache"
    }
  }
});

export const { signIn, signUp, signOut, useSession } = authClient;
